import React from 'react';
import { ArrowLeft } from 'lucide-react';

const SiteTerms = ({ onBack }) => (
    <div className="legal-page">
        <div className="legal-container">
            <button className="legal-back" onClick={onBack}>
                <ArrowLeft size={20} />
                Back to Home
            </button>

            <h1>Website Terms of Service</h1>
            <p className="legal-updated">Last Updated: February 20, 2026</p>

            <p>
                Welcome to <strong>www.eagletap.com</strong> (the "Website"), operated by
                <strong> EagleTap SRL</strong>. By accessing and using this Website, you agree
                to the following terms.
            </p>

            <h2>1. Use of the Website</h2>
            <p>
                This Website is provided for informational purposes to present our educational
                products and company values. You may browse the Website freely without registration.
            </p>

            <h2>2. Intellectual Property</h2>
            <p>
                All content on this Website — including text, graphics, logos, images, videos,
                design elements, and code — is the exclusive property of EagleTap SRL and is
                protected by Italian and international copyright laws.
            </p>
            <p>
                You may not copy, reproduce, distribute, or create derivative works from any
                content on this Website without prior written consent from EagleTap SRL.
            </p>

            <h2>3. Trademarks</h2>
            <p>
                "EagleTap" and its associated logos are trademarks of EagleTap SRL. Unauthorized use of these
                trademarks is prohibited.
            </p>

            <h2>4. External Links</h2>
            <p>
                This Website may contain links to third-party websites (e.g., Apple App Store,
                Google Play Store). EagleTap SRL is not responsible for the content or practices
                of these external sites.
            </p>

            <h2>5. Disclaimer</h2>
            <p>
                The Website and its content are provided "as-is" without warranties of any kind.
                EagleTap SRL does not guarantee that the Website will be available at all times
                or free from errors.
            </p>

            <h2>6. Limitation of Liability</h2>
            <p>
                EagleTap SRL shall not be liable for any direct, indirect, or consequential damages
                arising from the use or inability to use this Website.
            </p>

            <h2>7. Governing Law</h2>
            <p>
                These terms are governed by Italian law. For any dispute regarding consumers,
                the competent court is that of the user's place of residence.
            </p>

            <h2>8. Contact</h2>
            <p>
                For questions about these Terms of Service, contact us
                at: <strong>privacy@eagletap.com</strong>.
            </p>
        </div>
    </div>
);

export default SiteTerms;
